import ClientForm from "./ClientForm";

const ClientFormCreate = () => (
	<ClientForm record={null} contextLoading={false} />
);

export default ClientFormCreate;
